import { Flex, mediaMixin, spaceMixin, token } from '@zillow/constellation';
import { ContentBox } from '@zg-rentals/zrs-comet';
import styled, { css } from 'styled-components';

export const StyledFlexThreadContainer = styled(Flex)`
  overflow-y: auto;
  padding: 0 12px;
  flex: 1;
  width: 100%;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }

  &::-webkit-scrollbar:vertical {
    width: 10px;
  }

  &::-webkit-scrollbar:horizontal {
    height: 10px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid ${token('colors.white')};
    background-color: ${token('colors.gray300')};
  }
`;

export const StyledContentBoxNotification = styled(ContentBox)`
  position: absolute;
  width: 100%;
  left: 0;
  z-index: 1;
  padding: ${spaceMixin('xs')} ${spaceMixin('sm')};
  display: flex;
  align-items: center;

  ${mediaMixin(
    'xl',
    css`
      border-radius: 3px;
      width: stretch;
    `,
  )}
`;

export const StyledTimestampListItem = styled.li`
  list-style: none;
  text-align: center;
`;

export const StyledMessageListSkeletonContainer = styled(Flex)`
  display: flex;
  flex-direction: column;
  overflow: auto;
`;
